import XCircleIcon from "@heroicons/react/24/solid/XCircleIcon";
import { IconButton, Slide, Snackbar, SvgIcon } from "@mui/material";
import { useState } from "react";

function TransitionLeft(props) {
  return <Slide {...props} direction="left" />;
}

const useSnackbar = () => {
  const [open, setOpen] = useState(false);
  const [transition, setTransition] = useState(undefined);
  const [snackbarMessage, setSnackbarMessage] = useState("default");
  const [snackbarType, setSnackbarType] = useState("default");

  const handleClose = () => {
    setOpen(false);
  };

  function showSnackbar({ message, type = "default" }) {
    setSnackbarMessage(message);
    setSnackbarType(type);
    setOpen(true);
  }

  const snackbar = (
    <Snackbar
      sx={{
        "& .MuiSnackbarContent-message": {
          color: snackbarType === "error" ? "error.dark" : "primary.main",
        },

        "& .MuiSnackbarContent-root": {
          backgroundColor:
            snackbarType === "error" ? "error.light" : "background.default",
        },
      }}
      anchorOrigin={{ vertical: "top", horizontal: "right" }}
      open={open}
      onClose={handleClose}
      TransitionComponent={transition}
      message={snackbarMessage}
      key={transition ? transition.name : ""}
      action={
        <IconButton aria-label="close" onClick={handleClose}>
          <SvgIcon fontSize="small">
            <XCircleIcon />
          </SvgIcon>
        </IconButton>
      }
    />
  );

  return { showSnackbar, snackbar, setSnackbarMessage };
};

export default useSnackbar;
